import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import { Box } from "@mui/system";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useChosenDepartment } from "../../../../contexts/ChosenDepartment";
import { useUserGuideChat } from "../../../../contexts/UserGuideChatContext";
import { useIsMobile } from "../../../../hooks/useMobile";
import SystemButton from "../../../UIToolkit/SystemButton/SystemButton";
import { NewBroadcastMessageModal } from "./NewBroadcastMessageModal";

export const SendBroadcastMessage = () => {
	const navigate = useNavigate();
	const { chosenDepartment } = useChosenDepartment();
	const { isMobile } = useIsMobile();
	const [displayNewMessageModal, setDisplayNewMessageModal] = useState(false);
	const { changeHideStatus } = useUserGuideChat();

	const handleSendBroadcastMessage = useCallback(() => {
		const path = `/${chosenDepartment.department_id}/send-message`;
		navigate(path);
	}, [navigate, chosenDepartment]);

	const toggleNewMessageModal = useCallback(() => {
		if (isMobile) {
			handleSendBroadcastMessage();
		} else {
			setDisplayNewMessageModal((prev) => !prev);
		}
	}, [isMobile, handleSendBroadcastMessage]);

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 2,
				pt: isMobile ? 2 : 0,
			}}
		>
			{!isMobile && (
				<Box onClick={() => changeHideStatus(false)} sx={{ cursor: "pointer", display: "inline-flex" }}>
					<img src="/chat.svg" alt="chat" style={{ width: "36px", height: "36px" }} />
				</Box>
			)}
			{/* Annie walkthrough anchor. On desktop this opens the composer with no props at all, so everyone
			    reachable starts selected — the staff active here who have a userId AND a phoneNumber, which is
			    the "message all staff from a laptop" path the tour walks. On mobile the same button navigates
			    instead, and the tour is desktop-only. */}
			<SystemButton data-annie-target="staff-messages-new" onClick={toggleNewMessageModal} leadingIcon={<MessageOutlinedIcon style={{ fontSize: "20px" }} />}>
				Send New Message
			</SystemButton>
			{displayNewMessageModal && <NewBroadcastMessageModal onClose={toggleNewMessageModal} />}
		</Box>
	);
};
